import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService, DCO, SaveDCORequest, SnowflakeDco } from '../../../app.service';
import { AlertService } from '../../../common/alert.service';
import { LoadingService } from '../../../common/loading.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-dco-add-edit-dialog',
  templateUrl: './dco-add-edit-dialog.component.html',
  styleUrl: './dco-add-edit-dialog.component.scss'
})
export class DcoAddEditDialogComponent implements OnInit {

  isEditMode: boolean;
  //public snowflakeDCO: SnowflakeDco = null;
  public dcoToSave: DCO = null;

  public form: FormGroup;
  public nameFormControl: FormControl;
  public displayNameFormControl: FormControl;
  public descriptionFormControl: FormControl;
  public notificationEmailFormControl: FormControl;
  public activeFormControl: FormControl;

  constructor(
    private service: AppService,
    private alert: AlertService,
    private spinner: LoadingService,
    private dialog: MatDialogRef<DcoAddEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.isEditMode = this.data && this.data.isEditMode;
    this.dcoToSave = this.data ? { ...this.data.dcoToSave } : {};
    
    this.initForm();
  }

  private initForm() {
    this.form = new FormGroup({});
    this.nameFormControl = new FormControl('', [Validators.required]); 
    this.displayNameFormControl = new FormControl('', [Validators.required]);
    this.descriptionFormControl = new FormControl();
    this.notificationEmailFormControl = new FormControl();
    this.activeFormControl = new FormControl('', [Validators.required]);

    this.form.addControl('nameFormControl', this.nameFormControl); 
    this.form.addControl('displayNameFormControl', this.displayNameFormControl);
    this.form.addControl('descriptionFormControl', this.descriptionFormControl);
    this.form.addControl('notificationEmailFormControl', this.notificationEmailFormControl);
    this.form.addControl('activeFormControl', this.activeFormControl);

    if (this.dcoToSave) {
      this.nameFormControl.setValue(this.dcoToSave.name);
      this.displayNameFormControl.setValue(this.dcoToSave.displayName);
      this.descriptionFormControl.setValue(this.dcoToSave.description);
      this.notificationEmailFormControl.setValue(this.dcoToSave.notificationEmail);
      this.activeFormControl.setValue(this.dcoToSave.active);
    }
  }


  onClose(): void {
    // Close the dialog without saving changes
    this.dialog.close({ data: { refresh: false } });
  }

  onSave(): void {
    if (this.form.valid) {
      this.spinner.show();
      const request = new SaveDCORequest();
      request.dcoToSave = this.GetDCOFormValues();

      if (this.dcoToSave?.id) {
        request.dcoToSave.id = this.dcoToSave.id;
      }

      this.service.SaveDCO(request)
        .pipe(
          finalize(() => {
            // Hide the spinner after the request completes
            this.spinner.hide();
          })
        )
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.alert.success('Form submitted successfully!');

              // Close the dialog and let parent know to refresh the data.
              this.dialog.close({ data: { refresh: true } });

            } else {
              this.alert.warning(response.message);
            }
          },
          error: (error) => {
            console.error('Error submitting form:', error);
            this.alert.error('Failed to submit the form. Please try again.');
          }
        });
    } else {
      // Mark all fields as touched to show validation errors
      this.form.markAllAsTouched();
      this.alert.warning('Please correct the errors in the form before submitting.');
    }
  }

  GetDCOFormValues(): DCO {
    const dcoToReturn = new DCO();
    dcoToReturn.name = this.nameFormControl.value;
    dcoToReturn.displayName = this.displayNameFormControl.value;
    dcoToReturn.description = this.descriptionFormControl.value;
    dcoToReturn.notificationEmail = this.notificationEmailFormControl.value;
    dcoToReturn.active = this.activeFormControl.value;

    return dcoToReturn;
  }

}
